export const productId = {
    tegner: "tegner",
    companyexpense: "companyexpense",
    payroll: "payroll",
    vpy: "vpy",
    vismaonline: "vismaonline",
}

export const blikkProductEdition = {
    Pro: "blikkpro",
    Business: "blikkbusiness"
}